import { render, staticRenderFns } from "./Autores.vue?vue&type=template&id=586ba404&"
import script from "./Autores.vue?vue&type=script&lang=js&"
export * from "./Autores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports